module.exports = __webpack_public_path__ + "img/nantong_s.42024c9.png";